import {FormErrors} from 'redux-form';
import {getErrorTexts, maxLength} from 'validataion';
import {WithTranslationProps} from 'hoc/withTranslation';
import {WithSpeechkitConfigProps} from 'hoc/withSpeechkitConfig';

interface FormData {
    message: string;
}

type FormProps = WithTranslationProps & WithSpeechkitConfigProps;

export default function validate(values: FormData, {i18n, speechkitConfig}: FormProps) {
    const errorTexts = getErrorTexts(i18n);
    const errors: FormErrors<FormData> = {};

    if (!maxLength(values.message, speechkitConfig.ttsMessageLimit)) {
        errors.message = errorTexts.MAX_LEN;
    }

    return errors;
}
